/**
 * @module: 汇总
 * @author: Yawei Wang
 * @date: 2019-06-03 13:51:28
 */
import { ssoLogin, ssoLoginOut, AsyncProfileFn, profileFn, AsyncSso, goLogin, getLoginUrl } from './user';
import { initUnreadSocket } from './wkx_unread';
import { showPopup } from './ad';
export const user = {
  ssoLogin,
  ssoLoginOut,
  AsyncProfileFn,
  profileFn,
  AsyncSso,
  goLogin,
  getLoginUrl
};
export const wkxUnread = {
  initUnreadSocket
};
export const ad = {
  showPopup
};